import type { QuestionOut, QuickScanFinding } from '@/services/questionsService';

/**
 * Derive the effective status of a question based on its answer,
 * manual overrides, persisted finding, and ephemeral quick-scan result.
 */
export function getQuestionStatus(
  q: QuestionOut,
  quickScanResults: Record<number, QuickScanFinding>,
): 'pending' | 'ok' | 'vulnerable' | 'clarification' {
  if (q.vulnerabilities?.length) return 'vulnerable';
  if (!q.answer?.trim()) return 'pending';
  if (q.manual_status === 'vulnerable' || q.manual_status === 'quick_scan_vulnerable') return 'vulnerable';
  if (q.manual_status === 'ok' || q.manual_status === 'quick_scan_ok') return 'ok';
  if (q.manual_status === 'clarification' || q.manual_status === 'incorrect' || q.manual_status === 'quick_scan_clarification') return 'clarification';
  // Ephemeral quick-scan result (fallback for backward compat)
  const scan = quickScanResults[q.id];
  if (scan?.is_vulnerable) return 'vulnerable';
  if (scan?.needs_clarification) return 'clarification';
  if (scan) return 'ok';
  return 'pending';
}
